import Icon from 'components/Shared/Icon'

type Props = {
  onClickBack: () => void
  title: string
}

export default function Header({ onClickBack, title }: Props): JSX.Element {
  return (
    <>
      <div className="right-panel-back" onClick={onClickBack} aria-hidden>
        <Icon type="keyboard-back" />
        Database Collections
      </div>
      <h2 className="left-panel-title">
        <Icon type="data" />
        <span className="title">{title}</span>
      </h2>
    </>
  )
}
